export interface ISearchResult {
  id: string;
  name: string;
  source: string;
}

export const ERROR_COLOR = '#FA3D3D';

export enum Status {
  Active = 'Active',
  Inactive = 'Inactive'
}
